import { NormalTextInputField } from "@/components";

const HomeServicesSectionFormField = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-5-services-heading"
        fieldName="home-section-5-services-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-5-services-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="home-section-5-services-sub-heading"
        fieldName="home-section-5-services-sub-heading"
        placeholderText="Sub Heading"
        inputValue={stateDetails?.["home-section-5-services-sub-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />
    </>
  );
};

export default HomeServicesSectionFormField;
